/**
 * Created by rhett on 2019/4/11.
 */

import React, {Component} from 'react';
import CurActivityLi from "./CurActivityLi";
import ComingActivityLi from "./ComingActivityLi";


export default class MainPage extends Component
{


  componentDidMount()
  {
    window.scrollTo(0,0);
  }

  render()
  {
    return (
      <div id="MainPage">
        <div id="banner">
          <img src={require("./h5_banner1.png")} alt="" className="fullHorizontalImg"/>
        </div>

        <div id="MainIntro" className="content">
          <h1>城建 共和新路街道文化进社区系列活动</h1>
          <p>“共同行动”区域化党建单位上海城建置业发展有限公司与
            街道共同推出“党建+文化”项目：通过送文化进社区的形
            式，为社区提供公益优质资源。</p>
          <p>主要包含为学龄前儿童提供音乐、绘画等素质教育，为单
            位白领群体、在职党员提供瑜伽等健身项目，为中老年居
            民提供理财、养生等讲座等。</p>
        </div>

        <div className="hr1"></div>


        <div className="content">

          <h2>
            <div className="h2Icon"></div>
            五月份活动安排
          </h2>

          <div id="CurActivityUl">
            <CurActivityLi id={1} img={require("./h5_apply_drawing.png")} title="画画课程" desc="4月25日起    面向儿童"/>
            <CurActivityLi id={2} img={require("./h5_apply_yoga.png")} title="瑜伽课程" desc="4月25日起    面向中青年"/>
          </div>


          <p className="note">欢迎共和新路街道适龄居民踊跃参与，所有活动免费参加</p>
        </div>




        <div className="content" style={{marginTop:"31px"}}>
          <h2>
            <div className="h2Icon"></div>
            更多精彩敬请期待
          </h2>
        </div>


        <div id="ComingActivitySlide">
          <div id="ComingActivityUl" style={{width:((14+132)*3-14)+'px'}}>
            <ComingActivityLi title="六月份" desc="非洲鼓 / 健身操" img={require("./h5_june.png")}/>
            <ComingActivityLi title="七月份" desc="尤克里里 / 插花" img={require("./h5_july.png")}/>
            <ComingActivityLi title="未完待续…" desc="" img={require("./h5_future.png")}/>
          </div>
        </div>

        <div className="content" >
          <p className="note">共和新路街道文化进社区活动持续至12月份</p>
        </div>

        <div className="hr2"></div>



        {/**/}

        <div className="content">
          <img src={require("./h5_consult.png")} className="huodongzixunImg" alt=""/>
          <p className="footer">
            咨询电话:<a href="tel:18602039256">18602039256</a>
          </p>
        </div>

      </div>);
  }

}